module.exports = __webpack_public_path__ + "static/media/menu1.d40fa599.jpg";